import UpdateBiddingAuctionTypeModal from "./UpdateBiddingAuctionTypeModal";

export default UpdateBiddingAuctionTypeModal;